import i18n from "@/plugins/i18n";
import { toASCII } from "@/common/utilities";
import { head } from "lodash";

export const REQUEST_MAPPING = {
  COMMON_V1: "/api/v1",
  AUTH_V1: "/api/v1/auth",
  COMPANY: "/api/v1/company",
  USER: "/api/v1/users",
  CLASSIFICATION_REPORT: "/api/v1/classification/report",
  STORE: "/api/v1/store",
  CATEGORIES: "/api/v1/category",
};

export const REGEX = {
  EMAIL: /^\w+([.-]?\w+)[+\d]*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
  PHONE: /^[0-9-()]*$/,
  NUMBER: /^[0-9]*$/,
  HTML: /<(\/?)\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[\^'">\s]+))?)+\s*|\s*)\/?>/,
  SPECIAL_CHARACTERS: /^[a-zA-Z0-9_]+([._]?[a-zA-Z0-9_]+)*$/,
  KATAKANA: /^([a-zA-Z0-9ァ-ン 　$&+,:;=?@#\|'<>.\-_^*()%!~\\\/`]|ー)+$/,
  HIRAGANA: /^[a-zA-Z0-9ぁ-ん 　$&+,:;=?@#\|'<>.\-_^*()%!~\\\/`]+$/,
  DECIMAL_NUMBER_INS: /^([0-9]+\.?[0-9]*|\.[0-9]+)$/,
  NEGATIVE_DECIMAL: /^[-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/,
  NOT_NEGATIVE_INTEGER: /^\d*[1-9]\d*$/,
};

export const ITEMS_PER_PAGE = [10, 50, 100];

export const PAGING = {
  totalVisible: 10,
  itemsPerPageOption: ITEMS_PER_PAGE,
};

export const TYPE_COMPANIES_ITEMS = [
  { text: i18n.t("all"), value: null },
  { text: i18n.t("company"), value: 1 },
  { text: i18n.t("vendor"), value: 2 },
];

export const TYPE_COMPANIES = {
  COMPANY: i18n.t("company"),
  VENDOR: i18n.t("vendor"),
};

export const IS_ACTIVATED = {
  ACTIVATED: i18n.t("activated"),
  NOT_ACTIVATED: i18n.t("notActivated"),
  BOTH: null,
};

export const REQUIRED_ITEMS = [
  { text: i18n.t("required"), value: true },
  { text: i18n.t("optional"), value: false },
];

export const PROBLEM_STATUS_VALUES = {
  VALID: "VALID",
  INVALID: "INVALID",
};

export const PROBLEM_STATUSES = [
  /*{ text: i18n.t("all"), value: null },*/
  { text: i18n.t("activated"), value: PROBLEM_STATUS_VALUES.VALID },
  { text: i18n.t("notActivated"), value: PROBLEM_STATUS_VALUES.INVALID },
];

export const IS_ACTIVATED_ITEMS = [
  /*{ text: i18n.t("all"), value: null },*/
  { text: i18n.t("activated"), value: true },
  { text: i18n.t("notActivated"), value: false },
];

export const CONFIG_VALUES = {
  MAX_FILE_SIZE: 5, // MB
};

export const VALIDATE_RULE_COMMON = {
  INTEGER_NUMBER_COMMON: [
    (v) => {
      if (
        v !== undefined &&
        v !== null &&
        isNaN(v.split(",").join("")) &&
        isNaN(toASCII(v.split(",").join("")))
      ) {
        return i18n.t("msg.mustIntegerNumber");
      }
      if (
        v !== undefined &&
        v !== null &&
        (v.indexOf(".") > -1 ||
          v.indexOf("e") > -1 ||
          toASCII(v).indexOf(".") > -1)
      ) {
        return i18n.t("msg.mustIntegerNumber");
      }
      if (v !== undefined && v !== null && v.split(",").join("").length > 3) {
        return i18n.t("msg.numberLimit", [3]);
      }
      return true;
    },
  ],
};
export const VALIDATE_RULES = {
  REQUIRED: [(v) => !!v || i18n.t("msg.requiredCommon")],
  REQUIRED_TRUE_FALSE: [
    (v) => (v !== undefined && v !== null) || i18n.t("msg.requiredCommon"),
  ],
  REQUIRED_INCLUDE_ZERO: [
    (v) => !!v || v === 0 || i18n.t("msg.requiredCommon"),
  ],
  REQUIRED_MAX_LENGTH_50: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length !== 0 || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length <= 50 || i18n.t("msg.maxChar", ["は50"]),
  ],
  REQUIRED_MAX_LENGTH_100: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length !== 0 || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length <= 100 || i18n.t("msg.maxChar", ["は100"]),
  ],
  REQUIRED_MAX_LENGTH_255: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length <= 255 || i18n.t("msg.maxChar", ["は255"]),
  ],
  REQUIRED_MAX_LENGTH_500: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => !v || v.trim().length <= 500 || i18n.t("msg.maxChar", ["は500"]),
  ],
  MAX_LENGTH_255: [
    (v) => !v || v.trim().length <= 255 || i18n.t("msg.maxChar", ["は255"]),
  ],
  MAX_LENGTH_500: [
    (v) => !v || v.trim().length <= 500 || i18n.t("msg.maxChar", ["は500"]),
  ],
  ATTACHED_IMAGE: [
    (v) =>
      !v ||
      v.size / 1024 / 1024 <= CONFIG_VALUES.MAX_FILE_SIZE ||
      i18n.t("msg.overFileSize", [CONFIG_VALUES.MAX_FILE_SIZE]),
  ],
  ATTACHED_FILE: [
    (v) =>
      !v ||
      v.size / 1024 / 1024 <= CONFIG_VALUES.MAX_FILE_SIZE ||
      i18n.t("msg.overFileSize", [CONFIG_VALUES.MAX_FILE_SIZE]),
  ],
  INTEGER_NUMBER: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => v > 0 || i18n.t("msg.valueMustGreaterThan"),
    ...VALIDATE_RULE_COMMON.INTEGER_NUMBER_COMMON,
  ],
  INTEGER_NUMBER_ALLOW_0: [
    (v) => !!v || i18n.t("msg.requiredCommon"),
    (v) => v >= 0 || i18n.t("msg.valueMustNotNegative"),
    ...VALIDATE_RULE_COMMON.INTEGER_NUMBER_COMMON,
  ],
  INTEGER_NUMBER_NOT_REQUIRED: [
    (v) => {
      if (v !== undefined && v !== null && v !== "" && v <= 0) {
        return i18n.t("msg.valueMustGreaterThan");
      }
      return true;
    },
    ...VALIDATE_RULE_COMMON.INTEGER_NUMBER_COMMON,
  ],
};

export const CHECK_MARK = {
  ICON_1: "✔",
  ICON_2: "✘",
};

export const CIRCLE_NUMBERS = [
  "⑳",
  "⑲",
  "⑱",
  "⑰",
  "⑯",
  "⑮",
  "⑭",
  "⑬",
  "⑫",
  "⑪",
  "⑩",
  "⑨",
  "⑧",
  "⑦",
  "⑥",
  "⑤",
  "④",
  "③",
  "②",
  "①",
  "⓪",
];

export const HANDLE_ACTIONS = {
  DELETE: "DELETE",
  UPDATE_STATUS: "UPDATE_STATUS",
};

export const DISPLAY_TYPES = [
  {
    value: "SCROLL",
    text: "スクロール",
  },
  {
    value: "SWIPE",
    text: "スワイプ",
  },
];

export const PROBLEM_IMPORT_TEMPLATE_FILE_NAME = "取込フォーム記入例.docx";
export const PROBLEM_IMPORT_ALLOWED_EXTENSIONS = ".doc,.docx";
export const PROBLEM_IMPORT_ALLOWED_EXTENSION_ARRAY = ["doc", "docx"];
export const INSTRUCTION_UPLOAD_ALLOWED_EXTENSIONS = ".pdf";

export const IMAGE_KEYS = {
  OPEN: "【添付画像",
  CLOSE: "】",
  REGEX: /^(.*)】/,
};

export const COMMON_KEYS = {
  RESULT_TARGET_ID_ON_OFFLINE: "RESULT_TARGET_ID",
};

export const ALLOWED_EXTENSIONS = {
  IMAGES: "image/png, image/gif, image/jpg, image/jpeg",
  EXCEL: ".xlsx",
};

export const PAGINATION = {
  page: 1,
  itemsPerPage: 10,
  pageStart: 0,
  pageStop: 0,
  pageCount: 0,
  itemsLength: 0,
};

export const CLASSIFICATION_REPORT_HEADERS = [
  { text: "#", align: "start", value: "index", sortable: false },
  { text: "コード", align: "start", value: "index", sortable: false },
  { text: "分類名称", align: "start", value: "index", sortable: false },
  { text: "発注（数量）", align: "start", value: "index", sortable: false },
  { text: "発注（金額）", align: "start", value: "index", sortable: false },
  { text: "販売", align: "start", value: "index", sortable: false },
  { text: "廃棄", align: "start", value: "index", sortable: false },
];

export const CLASSIFICATION_DISPLAY_ITEM_VALUES = [
  {
    text: "発注（数量）",
    value: 1,
  },
  {
    text: "発注（金額）",
    value: 2,
  },
  {
    text: "販売",
    value: 3,
  },
  {
    text: "廃棄",
    value: 4,
  },
];

export const AGGREGATION_CORRECTION_DISPLAY_ITEM_VALUES = [
  {
    text: "発注数",
    value: 1,
    property: "numberOfOrders",
  },
  {
    text: "SKU数",
    value: 2,
    property: "janCodeByProduct",
  },
  {
    text: "販売数",
    value: 3,
    property: "saleQuantity",
  },
  {
    text: "値引数",
    value: 4,
    property: "discount",
  },
  {
    text: "廃棄数",
    value: 5,
    property: "cancelOrderAmount",
  },
  {
    text: "販売額",
    value: 6,
    property: "totalSaleMoney",
  },
  {
    text: "ロス額",
    value: 7,
    property: "lossAmount",
  },
  {
    text: "ロス率",
    value: 8,
    property: "lossRate",
  },
  {
    text: "欠品率",
    value: 9,
    property: "outOfStockRate",
  },
  {
    text: "入荷回数",
    value: 10,
    property: "countProductByOrder",
  },
  {
    text: "欠品回数",
    value: 11,
    property: "countProductByStockOut",
  },
  {
    text: "欠品SKU",
    value: 12,
    property: "countJanCodeByStockOut",
  },
  {
    text: "在庫日数",
    value: 13,
    property: "inventoryMoney",
  },
  {
    text: "在庫金額",
    value: 14,
    property: "inventoryDay",
  },
  {
    text: "採用率",
    value: 15,
    property: "adoptionRate",
  },
];

export function getFieldNameChartById(id) {
  if (!id) {
    return "";
  }
  switch (id) {
    case 1:
      return "orderQuantity";
    case 2:
      return "totalPrice";
    case 3:
      return "totalSaleMoney";
    case 4:
      return "cancelOrderAmount";
  }
}

export const DISPLAY_ITEM_TEXT = {
  1: CLASSIFICATION_DISPLAY_ITEM_VALUES[0].text,
  2: CLASSIFICATION_DISPLAY_ITEM_VALUES[1].text,
  3: CLASSIFICATION_DISPLAY_ITEM_VALUES[2].text,
  4: CLASSIFICATION_DISPLAY_ITEM_VALUES[3].text,
};

export function getClassificationHeaders(days, itemIds) {
  let headers = [
    {
      text: "#",
      align: "start",
      value: "index",
      sortable: false,
      rowSpans: 2,
      colSpans: 1,
    },
    {
      text: "コード",
      align: "start",
      value: "majorCode",
      sortable: false,
      rowSpans: 2,
      colSpans: 1,
    },
    {
      text: "分類名称",
      align: "start",
      value: "majorName",
      sortable: false,
      rowSpans: 2,
      colSpans: 1,
    },
  ];
  let displayItems = getDisplayItemsText(itemIds);
  if (
    !itemIds ||
    !days ||
    itemIds.length === 0 ||
    days.length === 0 ||
    displayItems.length === 0
  ) {
    return headers;
  }
  days.forEach((element) => {
    displayItems.forEach((item) => {
      let header = {
        text: item.text,
        align: "start",
        value: getFieldNameChartById(item.value),
        sortable: false,
        rowSpans: 1,
        colSpans: 3,
      };
      headers.push(header);
    });
  });
  return headers;
}

export function getValueClassificationReportById(id) {
  getFieldNameChartById;
}

export function getDisplayItemsText(itemIds) {
  if (!itemIds || itemIds.length === 0) {
    return CLASSIFICATION_DISPLAY_ITEM_VALUES;
  }
  let selectedItems = CLASSIFICATION_DISPLAY_ITEM_VALUES.filter((item) =>
    itemIds.includes(item.value),
  );
  return selectedItems;
}

// yyyy-mm-dd, yyyy/mm/dd
export function getJPDateFormat(dateStr, splitter) {
  if (!dateStr || dateStr.length !== 10) {
    return dateStr;
  }
  let arrDate = dateStr.split(splitter);
  let year = arrDate[0];
  let month = arrDate[1];
  let day = arrDate[2];
  return `${year}年${month}月${day}日`;
}

export function getJPDateFormatFull(dateStr, splitter) {
  if (!dateStr || dateStr.length !== 10) {
    return dateStr;
  }
  let arrDate = dateStr.split(splitter);
  let year = arrDate[0];
  let month = arrDate[1];
  let day = arrDate[2];
  return `${year}年${month}月${day}日`;
}

//format yyyy-mm-dd
export function getYearBefore(date) {
  let arrDate = date.split("-");
  let year = arrDate[0];
  let month = arrDate[1];
  let day = arrDate[2];
  let oneYearBefore = parseInt(year) - 1;
  return `${oneYearBefore}-${month}-${day}`;
}

export function getPercentIncrease(value, compareValue) {
  if (!value || !compareValue || value === 0 || compareValue === 0) {
    return "－";
  }
  let increase = ((value - compareValue) / compareValue).toFixed(2) * 100;
  return formatNumber(increase) + "%";
}

export function formatNumber(value) {
  let nf = new Intl.NumberFormat("en-US");
  return nf.format(value);
}

export const fakeData = {
  count: 0,
  tableByMajorResponses: [
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "041",
      majorNameKanji: "ソフトドリンク",
      numberOfOrders: "1000",
      janCodeByProduct: 11,
      saleQuantity: 22,
      discount: 11.22,
      cancelOrderAmount: 22.33,
      totalSaleMoney: 12.123,
      lossAmount: 11.22,
      lossRate: 12345,
      outOfStockRate: 1212,
      countProductByOrder: 1212,
      countProductByStockOut: 123,
      countJanCodeByStockOut: 1212,
      inventoryMoney: 121,
      inventoryDay: 100,
      adoptionRate: "11",
      isRowBelow: false,
    },
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "041",
      majorNameKanji: "ソフトドリンク",
      numberOfOrders: "1000",
      janCodeByProduct: 11,
      saleQuantity: 22,
      discount: 11.22,
      cancelOrderAmount: 22.33,
      totalSaleMoney: 12.99,
      lossAmount: 11.22,
      lossRate: 12345,
      outOfStockRate: 346,
      countProductByOrder: 345,
      countProductByStockOut: 345,
      countJanCodeByStockOut: 45654,
      inventoryMoney: 768,
      inventoryDay: 78,
      adoptionRate: "11",
      isRowBelow: true,
    },
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "047",
      majorNameKanji: "アイスクリーム",
      numberOfOrders: "1000",
      janCodeByProduct: 23,
      saleQuantity: 2323,
      discount: 11.22,
      cancelOrderAmount: 2332.33,
      totalSaleMoney: 233.123,
      lossAmount: 23.22,
      lossRate: 12345,
      outOfStockRate: 2332,
      countProductByOrder: 1212,
      countProductByStockOut: 324,
      countJanCodeByStockOut: 2233,
      inventoryMoney: 55,
      inventoryDay: 33,
      adoptionRate: "11",
      isRowBelow: false,
    },
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "047",
      majorNameKanji: "アイスクリーム",
      numberOfOrders: "1000",
      janCodeByProduct: 898,
      saleQuantity: 787,
      discount: 11.89,
      cancelOrderAmount: 768.33,
      totalSaleMoney: 233.123,
      lossAmount: 23.22,
      lossRate: 12345,
      outOfStockRate: 889,
      countProductByOrder: 1212,
      countProductByStockOut: 889,
      countJanCodeByStockOut: 2233,
      inventoryMoney: 898,
      inventoryDay: 33,
      adoptionRate: "11",
      isRowBelow: true,
    },
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "051",
      majorNameKanji: "和酒",
      numberOfOrders: "1000",
      janCodeByProduct: 23,
      saleQuantity: 2323,
      discount: 11.22,
      cancelOrderAmount: 2332.33,
      totalSaleMoney: 233.123,
      lossAmount: 23.22,
      lossRate: 12345,
      outOfStockRate: 2332,
      countProductByOrder: 1212,
      countProductByStockOut: 324,
      countJanCodeByStockOut: 2233,
      inventoryMoney: 55,
      inventoryDay: 33,
      adoptionRate: "11",
      isRowBelow: false,
    },
    {
      storeCode: "25553",
      storeName: "千葉轟町店",
      majorCode: "051",
      majorNameKanji: "和酒",
      numberOfOrders: "1000",
      janCodeByProduct: 898,
      saleQuantity: 787,
      discount: 11.89,
      cancelOrderAmount: 768.33,
      totalSaleMoney: 233.123,
      lossAmount: 23.22,
      lossRate: 12345,
      outOfStockRate: 889,
      countProductByOrder: 1212,
      countProductByStockOut: 889,
      countJanCodeByStockOut: 2233,
      inventoryMoney: 898,
      inventoryDay: 33,
      adoptionRate: "11",
      isRowBelow: true,
    },
  ],
};

export const REPORT_4_TBL_TYPE = {
  BEFORE: {
    id: 1,
  },
  AFTER: {
    id: 2,
  },
  AGGREGATION: {
    id: 3,
  },
};
